export const noPagination = {
  limit: 1000000,
  offset: 0,
};

export const defaultPagination = {
  limit: 10,
  offset: 0,
};

export const posPagination = {
  limit: 12,
  offset: 0,
};

export const apiDefaultMetaResponse = {
  current_page: 1,
  first_page: 1,
  first_page_url: "/?page=1",
  last_page: 1,
  last_page_url: "/?page=1",
  next_page_url: null,
  per_page: 1,
  previous_page_url: null,
  total: 0,
};

export const inputPlaceHolder = {
  phone_number: "Input Phone Number (e.g 877-1234-8191)",
};

export const defaultCountryCode = "+62";

export enum USER_TYPE_BACKGROUND {
  Partner = "#FFA1A1",
  Vendor = "#F7F6DF",
}
export enum PAYMENT_METHOD_BACKGROUND {
  full_payment = "#F6E0EE",
  pay_later = "#FFBBBB",
  deposit = "#FFD6A3",
}
export enum PAYMENT_STATUS_BACKGROUND {
  paid = "#A3BCFF",
  unpaid = "#FF8888",
}
export enum TRANSACTION_LABEL_BACKGROUND {
  subout = "#E0DFC6",
  subin = "#E3FFED",
  estimation_order = "#D4D4D4",
}

export enum OrderMethodValue {
  Delivery = "delivery",
  PickUp = "pickup",
}

export enum TransactionFlowValue {
  subin = "Sub-In",
  subout = "Sub-Out",
}

export const ChartStrokeColor = "#A2A9B2";
export const BarChartSize = 20;
export const LineChartStrokeWidth = 2;

export const countryCityDefaultValue = {
  country: "Indonesia",
  city: "Surabaya",
};

export const defaultValues = {
  country:
    process.env.REACT_APP_PRE_IS_PRE_FILL_COUNTRY_AND_CITY === "1"
      ? countryCityDefaultValue.country
      : undefined,
  city:
    process.env.REACT_APP_PRE_IS_PRE_FILL_COUNTRY_AND_CITY === "1"
      ? countryCityDefaultValue.city
      : undefined,
};

export const multiplier =
  Number(process.env.REACT_APP_FONT_SIZE_MULTIPLIER) || 1.3;

export const fontSize = {
  textSm: String(14 * multiplier),
  textXs: String(12 * multiplier),
  text2xs: String(10 * multiplier),
  text3xs: String(8 * multiplier),
};

// Flag in PnL Report so that structure align with design
export const NET_INCOME_ID = -1;

export const accessControl = {
  customerType: "Master Data - Customer Type",
  productPackage: "Product Management - Product Package",
  productList: "Product Management - Product List",
  businessOperation: "Master Data - Business Operation",
  productCategory: "Master Data - Product Category",
  packageCategory: "Master Data - Package Category",
  stockUnit: "Master Data - Item Stock Unit",
  adminManagement: "Admin Management - Admin List",
  pos: "POS",
  warehouse: "Master Data - Warehouse Data",
  stockPurchase: "Product Management - Stock Purchase",
  supplierList: "Master Data - Supplier List",
  salespersonList: "Master Data - Salesperson List",
  promoCode: "Promo Code",
  additionalFee: "Master Data - Additional Fee",
  expenseIncome: "Master Data - Expense and Income Category",
  expenseReport: "Report | Expenses & Income Report",
  customerList: "User Management - Customer List",
  userManagementCustomerListAllowAssignSalesperson:
    "User Management - Customer List | Allow Assign Salesperson",
  salesperson: "User Management - Salesperson List",
  adminManagementChangePassword: "Admin Management - Admin List | Change Admin Password",
};

export const ERROR_MESSAGES = {
  required: "Required",
};
